import DynamicComponentError from "%/dynamic-component-editor/errors/dynamic-component-error";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { entityBindingProblems } from "%/dynamic-component-editor/helpers/entity-binding-problems";

export const SmartFeedEntityDynamicElementMixin = {
  extends: DynamicElementMixin,
  // Every feed-entity element (story/season/episode/event/show/subscription cards) must
  // bind to a DC-provided context or it's broken — one source of truth, no fallback. #166
  configurationProblems: entityBindingProblems,
  inject: {
    inBuilderEditScope: {
      from: "inBuilderEditScope",
      default: false,
    },
  },
  computed: {
    entity() {
      if (this.editMode || this.inBuilderEditScope) {
        return this.getExampleEntity();
      }
      return this.getRealEntity();
    },
  },
  methods: {
    getSmartFeedEntityStore() {
      if (!this.$options.entityStore || typeof this.$options.entityStore !== "function") {
        return null;
      }
      return this.$options.entityStore(this.$pinia);
    },
    // Subclasses are expected to override this with the lookup that
    // matches their entity surface. The default here is a best-effort
    // probe of the smart-feed entity store keyed by `entityId`. Both
    // the missing-store and missing-entry cases fall back to
    // `getExampleEntity()` rather than throwing, so a production page
    // whose real-entity wiring isn't fully set up still renders with
    // the example shape instead of crashing the whole canvas.
    getRealEntity() {
      const entityStore = this.getSmartFeedEntityStore();
      if (!entityStore) {
        return this.getExampleEntity();
      }
      const found = entityStore.entities?.[this.entityId];
      if (!found) {
        return this.getExampleEntity();
      }
      return found;
    },
    getExampleEntity() {
      if (!this.$options.exampleEntity || typeof this.$options.exampleEntity !== "object") {
        throw new DynamicComponentError(
          "Dynamic component element which extends SmartFeedEntityDynamicElementMixin must define an exampleEntity property or override the getExampleEntity method",
          {
            componentName: this.$options.name,
          },
        );
      }
      return this.$options.exampleEntity;
    },
  },
};
